export default __webpack_public_path__ + "static/media/fade.3fd7df30.png";